// extracted by mini-css-extract-plugin
export default {"delete-img":"DeleteImg_delete-img__AeE4q","delete-spn":"DeleteImg_delete-spn__07B+G"};